import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "warning-test-modal" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "counterTitle" }, "Sair desse resultado?", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-content upperSpace" }, " Ao voltar, este autoteste será encerrado e você não terá mais acesso ao cartão de resposta. Garanta que você baixou ou compartilhou seus resultados. ", -1)
const _hoisted_4 = { class: "action-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_modal, {
      class: "custom-modal",
      ref: "base-modal"
    }, {
      content: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-default btn-secondary upperSpace buttonSmall",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal(false)))
          }, " Cancelar "),
          _createElementVNode("button", {
            class: "btn btn-default btn-primary upperSpace buttonLarge",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reloadPage && _ctx.reloadPage(...args)))
          }, " Refazer o teste ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}